import React, { useState } from "react";
import firebase from "../../../utils/firebase";
//import { useHistory } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Link } from "react-router-dom";
import { setAlert } from "../../../slices/alertSlice";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import {
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import Button from "../../../components/MaterialKit/CustomButtons/Button";
import { Helmet } from "react-helmet";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";

import { CheckFormikValues } from "../../../components/Formik/CheckFormikValues";

import CardBody from "components/MaterialKit/Card/CardBody.js";
import CardHeader from "components/MaterialKit/Card/CardHeader.js";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CardFooter from "components/MaterialKit/Card/CardFooter";
import { LOGIN } from "constants/routes";

const useStyles = makeStyles(styles);

const RegistrationForm = (props) => {
  const [uiConfig, setUiConfig] = useState({
    signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
    },
  });
  const classes = useStyles();
  const dispatch = useDispatch();
  // const history = useHistory();

  const check = false;

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue,
  } = props;
  const {
    auth: { loading },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  const [view, setView] = useState(false);
  const [view2, setView2] = useState(false);
  const openCloudWidget = () => {
    window.cloudinary
      .createUploadWidget(
        {
          cloudName: "gamers-world",
          uploadPreset: "r26tykft",
          resourceType: "image",
        },
        (error, result) => {
          if (!error && result && result.event === "success") {
            setFieldValue("photo", result.info.secure_url);
          }
        }
      )
      .open();
  };

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <Helmet>
        <script
          src="https://widget.cloudinary.com/v2.0/global/all.js"
          type="text/javascript"
        ></script>
      </Helmet>
      <CardHeader color="black" className={classes.cardHeader}>
        <h3>Register</h3>

        <div className={classes.socialLine}>
          {/* <Button
            justIcon
            simple
            href="#pablo"
            target="_blank"
            onClick={(e) => e.preventDefault()}
          >
            <i className={"fab fa-steam"} style={{ fontSize: "1.5rem" }} />
          </Button>
          <Button
            justIcon
            simple
            href="#pablo"
            target="_blank"
            onClick={(e) => e.preventDefault()}
          >
            <i className={"fab fa-facebook"} style={{ fontSize: "1.5rem" }} />
          </Button>
          <Button
            justIcon
            simple
            href="#pablo"
            target="_blank"
            onClick={(e) => e.preventDefault()}
          >
            <i
              className={"fab fa-google-plus-g"}
              style={{ fontSize: "1.5rem" }}
            />
          </Button> */}
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        </div>
      </CardHeader>

      <CardBody>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Name"
            placeholder="Enter Name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.name && touched.name}
            helperText={errors.name && touched.name && errors.name}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-user" />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Email Address"
            placeholder="Enter Email"
            name="email"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email && touched.email}
            helperText={errors.email && touched.email && errors.email}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Username"
            placeholder="Enter username"
            name="username"
            value={values.username}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.username && touched.username}
            helperText={errors.username && touched.username && errors.username}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-user" />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Password"
            placeholder="Enter Password"
            type={view ? "text" : "password"}
            name="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password && touched.password}
            helperText={errors.password && touched.password && errors.password}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {!view ? (
                    <VisibilityIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => setView(!view)}
                    />
                  ) : (
                    <VisibilityOffIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => setView(!view)}
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Confirm Password"
            placeholder="Enter Password"
            type={view2 ? "text" : "password"}
            name="confirmPassword"
            value={values.confirmPassword}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.confirmPassword && touched.confirmPassword}
            helperText={
              errors.confirmPassword &&
              touched.confirmPassword &&
              errors.confirmPassword
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {!view2 ? (
                    <VisibilityIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => setView2(!view2)}
                    />
                  ) : (
                    <VisibilityOffIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => setView2(!view2)}
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <FormControl style={{ padding: "1rem", width: "100%" }}>
          <TextField
            variant="outlined"
            label="Profile Picture"
            placeholder="Select Picture"
            type="text"
            name="photo"
            value={values.photo}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.photo && touched.photo}
            helperText={errors.photo && touched.photo && errors.photo}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <CloudUploadIcon
                    style={{ cursor: "pointer" }}
                    onClick={openCloudWidget}
                  />
                </InputAdornment>
              ),
              readOnly: true,
            }}
          />
        </FormControl>
      </CardBody>
      <CardFooter>
        <Button
          onClick={() => {
            if (
              !values.name ||
              !values.email ||
              !values.password ||
              !values.confirmPassword
            ) {
              dispatch(setAlert("Please fill the form properly!", "warning"));
            }
          }}
          type="submit"
          color="warning"
          round
          fullWidth
          loading={loading}
        >
          Register
        </Button>
      </CardFooter>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          padding: "1rem",
        }}
      >
        <div
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Link
            to={LOGIN}
            style={{
              textDecoration: "none",
            }}
          >
            Already have an account?{"  "}
            <Button simple variant="contained" color="primary" size="lg">
              Login
            </Button>
          </Link>
        </div>
      </div>
      {check ? <CheckFormikValues {...props} /> : ""}
    </form>
  );
};

export { RegistrationForm };
